export default __webpack_public_path__ + "static/media/crimeAdd.cba88d94.png";